import React from "react";
import { Navigate } from "react-router-dom";

const DefaultPath = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const params = ["raNumber", "lastName", "dob", "accountType"].reduce((accum, key) => {
    const value = urlParams.get(key);
    if (!value) {
      return accum;
    }

    accum.push({ key, value });
    return accum;
  }, []);

  if (params.length === 0) {
    return <Navigate to="/login" />;
  }

  const loginUrl = params.reduce((redirectLink, { key, value }) => {
    return `${redirectLink}&${key}=${value}`;
  }, "/login?");

  return <Navigate to={loginUrl} />;
};

export default DefaultPath;
